(function () {
  "use strict";

  var DD_CARD_SALE={"tr":"İndirim","en":"Sale","es":"Oferta","ru":"Скидка","ar":"خصم","de":"Angebot","fr":"Promotion"};
  function ddCardSale(){return DD_CARD_SALE[String(document.documentElement.lang||"tr").toLowerCase().split("-")[0]]||DD_CARD_SALE.tr;}

  function parseJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function formatMoney(cents, fallback) {
    var number = Number(cents);
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "TRY";
    var locale = document.documentElement.lang || "tr-TR";

    if (Number.isFinite(number)) {
      try {
        if (currency === "TRY") {
          // TRY prices keep meaningful decimals while omitting trailing zeroes.
          return new Intl.NumberFormat("tr-TR", {
            minimumFractionDigits: number % 100 === 0 ? 0 : 2,
            maximumFractionDigits: 2
          }).format(number / 100) + " TL";
        }
        return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(number / 100);
      } catch (error) {}
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined);
      } catch (error) {}
    }

    return fallback || "";
  }

  function formatInitialMoney(root) {
    Array.prototype.slice.call(root.querySelectorAll("[data-fhp-money-cents]")).forEach(function (node) {
      writeMoney(node, node.getAttribute("data-fhp-money-cents"), node.textContent);
    });
  }

  function writeMoney(node, cents, fallback) {
    if (!node) return "";
    var text = formatMoney(cents, fallback);
    node.textContent = text;
    node.classList.add("notranslate");
    node.setAttribute("translate", "no");
    node.setAttribute("data-faire-original-try-price", text);
    return text;
  }

  function resolveDiscountPercent(variant, configuredPercent) {
    var percent = toNumber(configuredPercent, 0);
    if (percent > 0) return percent;
    if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return 0;
    return Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
  }

  function discountText(variant, prefix, suffix, configuredPercent, showDiscountAmount) {
    if (!variant) return "";
    var percent = resolveDiscountPercent(variant, configuredPercent);
    if (!percent) return "";

    var text = (String(prefix || "") + " %" + percent + " " + String(suffix || "")).replace(/\s+/g, " ").trim();
    if (showDiscountAmount) {
      var discountedPrice = Math.round((variant.price * (100 - percent)) / 100);
      text += " " + formatMoney(discountedPrice, "");
    }
    return text;
  }

  function findVariantByExactOptions(productData, selectedOptions) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    return (
      productData.variants.find(function (variant) {
        if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) return false;
        for (var i = 0; i < selectedOptions.length; i += 1) {
          if (variant.options[i] !== selectedOptions[i]) return false;
        }
        return true;
      }) || null
    );
  }

  function findVariantByPartial(productData, selectedOptions, changedIndex) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    var preferred = productData.variants.find(function (variant) {
      if (!Array.isArray(variant.options)) return false;
      if (variant.options[changedIndex] !== selectedOptions[changedIndex]) return false;
      return variant.available;
    });
    if (preferred) return preferred;
    return (
      productData.variants.find(function (variant) {
        return Array.isArray(variant.options) && variant.options[changedIndex] === selectedOptions[changedIndex];
      }) || null
    );
  }

  function initSection(root) {
    if (!root || root.dataset.fhpInit === "1") return;
    root.dataset.fhpInit = "1";

    var productData = parseJson(root.querySelector("[data-fhp-product-json]"));
    if (!productData || !Array.isArray(productData.variants) || !productData.variants.length) return;

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-options]"));
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-option]"));
    var optionLabels = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-option-label]"));
    var variantInput = root.querySelector("[data-fhp-variant-input]");
    var priceNode = root.querySelector("[data-fhp-price]");
    var compareNode = root.querySelector("[data-fhp-compare]");
    var salePercentNode = root.querySelector("[data-fhp-sale-percent]");
    var priceRow = priceNode ? priceNode.closest(".fhp-price") : null;
    var discountLineNode = root.querySelector("[data-fhp-discount-line]");
    var discountValueNode = root.querySelector("[data-fhp-discount-value]");
    var installmentNode = root.querySelector("[data-fhp-installment]");
    var installmentRow = root.querySelector("[data-fhp-installment-row]");
    var installmentPlanNodes = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-installment-plan]"));
    var addButton = root.querySelector("[data-fhp-add-btn]");
    var stockRow = root.querySelector("[data-fhp-stock-row]");
    var stockTextNode = root.querySelector("[data-fhp-stock-text]");
    var form = root.querySelector("[data-fhp-form]");
    var mediaItems = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-media-item]"));
    var thumbButtons = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-thumb]"));
    var favoriteButtons = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-fav-toggle]"));
    var variantAccordions = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-var-acc]"));
    var variantAccordionToggles = Array.prototype.slice.call(root.querySelectorAll("[data-fhp-var-toggle]"));
    var qtyInput = root.querySelector("[data-fhp-qty-input]");
    var qtyInc = root.querySelector("[data-fhp-qty-inc]");
    var qtyDec = root.querySelector("[data-fhp-qty-dec]");

    if (!variantInput || !form || !addButton) return;

    var addLabel = root.dataset.fhpAddLabel || "Sepete Ekle";
    var addingLabel = root.dataset.fhpAddingLabel || "Ekleniyor...";
    var addedLabel = root.dataset.fhpAddedLabel || "Sepete Eklendi";
    var errorLabel = root.dataset.fhpErrorLabel || "Tekrar Dene";
    var soldLabel = root.dataset.fhpSoldLabel || "Tukendi";
    var inStockLabel = root.dataset.fhpInStockLabel || "Stokta";
    var outStockLabel = root.dataset.fhpOutStockLabel || "Stokta Yok";
    var favDefault = root.dataset.fhpFavDefault || "Favorilere Ekle";
    var favActive = root.dataset.fhpFavActive || "Favorilerde";
    var discountPrefix = root.dataset.fhpDiscountPrefix || "Sepette Ek";
    var discountSuffix = root.dataset.fhpDiscountSuffix || ddCardSale();
    var showDiscount = root.dataset.fhpShowDiscount === "true";
    var showComparePrice = root.dataset.fhpShowComparePrice === "true";
    var configuredDiscountPercent = toNumber(root.dataset.fhpCartDiscountPercent, 0);
    var showDiscountAmount = root.dataset.fhpShowDiscountAmount === "true";
    var installmentCount = Math.max(1, toNumber(root.dataset.fhpInstallmentCount, 3));
    var cartUrl = ((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + ".js" : root.dataset.fhpCartUrl) || "/cart/add.js").trim() || "/cart/add.js";

    var initialVariantId = toNumber(variantInput.value, null);
    var currentVariant =
      productData.variants.find(function (variant) {
        return variant.id === initialVariantId;
      }) || productData.variants[0];

    var selectedOptions = (currentVariant.options || []).slice();

    function setActiveMedia(mediaId) {
      if (!mediaId) return;
      if (typeof root.__ddProductGalleryActivate === "function") {
        root.__ddProductGalleryActivate(mediaId, true);
        return;
      }
      mediaItems.forEach(function (item) {
        item.classList.toggle("is-active", String(item.getAttribute("data-media-id")) === String(mediaId));
      });
      thumbButtons.forEach(function (thumb) {
        thumb.classList.toggle("is-active", String(thumb.getAttribute("data-media-id")) === String(mediaId));
      });
    }

    function setVariantAccordionState(targetAccordion, open) {
      if (!targetAccordion) return;
      var targetBody = targetAccordion.querySelector("[data-fhp-var-body]");
      var targetToggle = targetAccordion.querySelector("[data-fhp-var-toggle]");
      targetAccordion.classList.toggle("is-open", !!open);
      if (targetBody) {
        targetBody.hidden = !open;
      }
      if (targetToggle) {
        targetToggle.setAttribute("aria-expanded", open ? "true" : "false");
      }
    }

    // Never start a PDP with an expanded variant panel, including editor reloads.
    variantAccordions.forEach(function (acc) {
      setVariantAccordionState(acc, false);
    });

    variantAccordionToggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var currentAccordion = toggle.closest("[data-fhp-var-acc]");
        if (!currentAccordion) return;
        var willOpen = !currentAccordion.classList.contains("is-open");
        variantAccordions.forEach(function (acc) {
          setVariantAccordionState(acc, acc === currentAccordion ? willOpen : false);
        });
      });
    });

    function syncOptionsUI() {
      optionGroups.forEach(function (group) {
        var optionIndex = toNumber(group.getAttribute("data-option-index"), 0);
        var selectedValue = selectedOptions[optionIndex] || "";
        var selectedButton = null;
        Array.prototype.slice.call(group.querySelectorAll("[data-fhp-option]")).forEach(function (button) {
          var isActive = button.getAttribute("data-option-value") === selectedValue;
          button.classList.toggle("is-active", isActive);
          if (isActive) selectedButton = button;
        });

        var previewNode = root.querySelector('[data-fhp-option-preview="' + optionIndex + '"]');
        if (previewNode && selectedButton) {
          var thumbSrc = selectedButton.getAttribute("data-option-thumb");
          var optionValue = selectedButton.getAttribute("data-option-value") || "";
          if (thumbSrc) {
            previewNode.src = thumbSrc;
            previewNode.alt = optionValue;
            previewNode.hidden = false;
            if (previewNode.parentElement) previewNode.parentElement.hidden = false;
          }
        }
      });

      optionLabels.forEach(function (label) {
        var optionIndex = toNumber(label.getAttribute("data-fhp-option-label"), 0);
        label.textContent = selectedOptions[optionIndex] || "";
      });
    }

    function syncVariantUI(variant) {
      if (!variant) return;
      currentVariant = variant;
      selectedOptions = (variant.options || []).slice();
      variantInput.value = String(variant.id);
      syncOptionsUI();

      if (priceNode) {
        writeMoney(priceNode, variant.price, priceNode.textContent);
      }

      var hasCompare = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      if (priceRow) {
        priceRow.classList.toggle("is-sale", hasCompare);
      }
      if (compareNode) {
        compareNode.hidden = !hasCompare;
        if (hasCompare) {
          writeMoney(compareNode, variant.compare_at_price, compareNode.textContent);
        } else {
          compareNode.textContent = "";
          compareNode.removeAttribute("data-faire-original-try-price");
        }
      }
      if (salePercentNode) {
        var salePercent = hasCompare
          ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
          : 0;
        salePercentNode.hidden = !hasCompare || salePercent <= 0;
        salePercentNode.textContent = salePercent > 0 ? "-%" + salePercent + " " + ddCardSale() : "";
      }

      if (discountLineNode) {
        var discountLabel = discountText(variant, discountPrefix, discountSuffix, configuredDiscountPercent, showDiscountAmount);
        if (showDiscount && discountLabel) {
          discountLineNode.hidden = false;
          if (discountValueNode) {
            discountValueNode.textContent = discountLabel;
          } else {
            discountLineNode.textContent = discountLabel;
          }
        } else {
          discountLineNode.hidden = true;
        }
      }

      if (installmentRow && installmentNode) {
        writeMoney(installmentNode, Math.round(variant.price / installmentCount), installmentNode.textContent);
      }
      installmentPlanNodes.forEach(function (node) {
        var count = Math.max(1, toNumber(node.getAttribute("data-fhp-installment-plan"), 1));
        writeMoney(node, Math.round(variant.price / count), node.textContent);
      });

      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? addLabel : soldLabel;

      if (stockRow && stockTextNode) {
        stockRow.classList.toggle("is-in", !!variant.available);
        stockRow.classList.toggle("is-out", !variant.available);
        stockTextNode.textContent = variant.available ? inStockLabel : outStockLabel;
      }

      if (variant.featured_media && variant.featured_media.id) {
        setActiveMedia(variant.featured_media.id);
      }

      if (history.replaceState && window.location.protocol !== "file:") {
        try {
          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set("variant", String(variant.id));
          history.replaceState({}, "", nextUrl.pathname + nextUrl.search + nextUrl.hash);
        } catch (error) {}
      }
    }

    optionButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var optionIndex = toNumber(button.getAttribute("data-option-index"), 0);
        var optionValue = button.getAttribute("data-option-value");
        var currentAccordion = button.closest("[data-fhp-var-acc]");
        selectedOptions[optionIndex] = optionValue;

        var matched = findVariantByExactOptions(productData, selectedOptions);
        if (!matched) {
          matched = findVariantByPartial(productData, selectedOptions, optionIndex);
        }
        if (matched) {
          syncVariantUI(matched);
        } else {
          syncOptionsUI();
        }
        if (currentAccordion) {
          setVariantAccordionState(currentAccordion, false);
        }
      });
    });

    // Clicking elsewhere on the product page dismisses every option panel.
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-fhp-var-acc]") && root.contains(event.target)) return;
      variantAccordions.forEach(function (acc) {
        setVariantAccordionState(acc, false);
      });
    });
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      variantAccordions.forEach(function (acc) {
        setVariantAccordionState(acc, false);
      });
    });
    // Desktop hover exit closes an expanded menu, without affecting touch devices.
    root.addEventListener("pointerout", function (event) {
      if (event.pointerType !== "mouse" && event.pointerType !== "pen") return;
      var acc = event.target.closest("[data-fhp-var-acc]");
      if (!acc || !acc.classList.contains("is-open")) return;
      if (event.relatedTarget && acc.contains(event.relatedTarget)) return;
      setVariantAccordionState(acc, false);
    });

    favoriteButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var active = button.classList.toggle("is-active");
        button.textContent = active ? favActive : favDefault;
      });
    });

    function setButtonTempState(label, disable) {
      addButton.textContent = label;
      addButton.disabled = disable;
    }

    function normalizeQuantity(value) {
      var parsed = parseInt(value, 10);
      if (!Number.isFinite(parsed) || parsed < 1) return 1;
      return parsed;
    }

    if (qtyInput) {
      qtyInput.value = String(normalizeQuantity(qtyInput.value));
      qtyInput.addEventListener("input", function () {
        qtyInput.value = String(normalizeQuantity(qtyInput.value));
      });
      qtyInput.addEventListener("blur", function () {
        qtyInput.value = String(normalizeQuantity(qtyInput.value));
      });
    }

    if (qtyInc && qtyInput) {
      qtyInc.addEventListener("click", function () {
        qtyInput.value = String(normalizeQuantity(qtyInput.value) + 1);
      });
    }

    if (qtyDec && qtyInput) {
      qtyDec.addEventListener("click", function () {
        var next = normalizeQuantity(qtyInput.value) - 1;
        qtyInput.value = String(next < 1 ? 1 : next);
      });
    }

    var submitPending = false;

    function refreshCartDrawerAfterAdd(payload) {
      var drawer = document.querySelector("cart-drawer");
      if (!drawer) return Promise.resolve();

      var sectionId = String(window.__ddCartDrawerSectionId || "cart-drawer");
      if (payload && payload.sections && typeof drawer.renderContents === "function") {
        try {
          if (payload.sections[sectionId] || payload.sections["cart-drawer"]) {
            drawer.renderContents(payload);
            if (typeof drawer.open === "function") drawer.open();
            return Promise.resolve();
          }
        } catch (error) {}
      }

      return fetch("/cart?section_id=" + encodeURIComponent(sectionId), {
        credentials: "same-origin",
        headers: { Accept: "text/html" }
      })
        .then(function (response) {
          if (!response.ok) throw new Error("cart_drawer_refresh_error");
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, "text/html");
          var nextDrawer = parsed.querySelector("cart-drawer");
          var currentInner = drawer.querySelector(".drawer__inner");
          var nextInner = nextDrawer && nextDrawer.querySelector(".drawer__inner");
          if (!currentInner || !nextInner) throw new Error("cart_drawer_markup_error");
          currentInner.innerHTML = nextInner.innerHTML;
          drawer.classList.toggle("is-empty", nextDrawer.classList.contains("is-empty"));
          if (typeof drawer.open === "function") drawer.open();
        });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (submitPending || !currentVariant || !currentVariant.available) return;

      submitPending = true;
      setButtonTempState(addingLabel, true);
      addButton.setAttribute("aria-busy", "true");

      if (window.location.protocol === "file:") {
        window.setTimeout(function () {
          submitPending = false;
          addButton.removeAttribute("aria-busy");
          setButtonTempState(addedLabel, true);
          window.setTimeout(function () {
            syncVariantUI(currentVariant);
          }, 1200);
        }, 360);
        return;
      }

      var formData = new FormData(form);
      formData.set("id", String(currentVariant.id));
      formData.set("quantity", String(normalizeQuantity(qtyInput ? qtyInput.value : formData.get("quantity"))));
      if (window.__ddCartDrawerSectionId) {
        formData.set("sections", String(window.__ddCartDrawerSectionId) + ",cart-icon-bubble");
        formData.set("sections_url", window.location.pathname);
      }

      document.dispatchEvent(
        new CustomEvent("dd:cart-pending", {
          detail: { source: "fhp", trigger: addButton }
        })
      );

      fetch(cartUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error("add_error");
          return response.json();
        })
        .then(function (payload) {
          return refreshCartDrawerAfterAdd(payload)
            .catch(function () {})
            .then(function () {
              document.dispatchEvent(
                new CustomEvent("dd:cart-added", {
                  detail: {
                    payload: payload,
                    source: "fhp",
                    trigger: addButton
                  }
                })
              );
              setButtonTempState(addedLabel, true);
              window.setTimeout(function () {
                syncVariantUI(currentVariant);
              }, 1200);
            });
        })
        .catch(function () {
          setButtonTempState(errorLabel, false);
          window.setTimeout(function () {
            syncVariantUI(currentVariant);
          }, 1200);
        })
        .finally(function () {
          submitPending = false;
          addButton.removeAttribute("aria-busy");
        });
    });

    formatInitialMoney(root);
    syncVariantUI(currentVariant);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll("[data-fhp-root]")).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    Array.prototype.slice.call(event.target.querySelectorAll("[data-fhp-root]")).forEach(initSection);
  });
})();
